import BackendService from './BackendService';
import AnalyticsHelper from 'helpers/AnalyticsHelper';
import { CLARITY_EVENTS } from 'const';

async function getItems(params) {
  const response = await getItemsResponse(params);
  return response?.data;
}
async function getItemsResponse(params) {
  return BackendService.get('/items/', {}, params);
}
async function getItemNames(data = {}) {
  return BackendService.getData('/items/name_list/', data);
}
async function updateItem(itemId, data = {}) {
  return BackendService.put(`/item/${itemId}/`, data);
}
async function addItem(data = {}) {
  try {
    const response = await BackendService.postData('/items/', data);
    AnalyticsHelper.event(CLARITY_EVENTS.CREATE_ITEM);
    return response;
  } catch (error) {
    AnalyticsHelper.event(CLARITY_EVENTS.CREATE_ITEM_FAILED);
    throw error;
  }
}
async function getItemCategories(data = {}) {
  return BackendService.getData('/categories/', data);
}
async function addItemCategory(data = {}) {
  try {
    const response = await BackendService.postData('/categories/', data);
    AnalyticsHelper.event(CLARITY_EVENTS.CREATE_CATEGORY);
    return response;
  } catch (error) {
    AnalyticsHelper.event(CLARITY_EVENTS.CREATE_CATEGORY_FAILED);
    throw error;
  }
}
async function deleteItemCategory(id) {
  return BackendService.destroy(`/category/${id}/`);
}
async function uploadCategoryImage(data = {}, id) {
  return BackendService.postData(`/category/${id}/image/`, data);
}
async function uploadItemImage(data = {}, id) {
  return BackendService.postData(`/item/${id}/image/`, data);
}
async function editItemCategory(data = {}, id) {
  return BackendService.put(`/category/${id}/`, data);
}
async function updatePlu() {
  return BackendService.postData('/items/update_plu_text/', '');
}
async function updateItems(data) {
  return BackendService.postData('/items/batch/', data);
}
async function deleteItem(id) {
  return BackendService.destroy(`/item/${id}/`);
}
async function getItemAdvanced(id) {
  return BackendService.getData(`/items/${id}/advanced/`);
}
async function updateItemAdvanced(data = {}, id) {
  return BackendService.put(`/items/${id}/advanced/`, data);
}
async function getHighestPlu() {
  return BackendService.getData('/items/highest-plu/');
}
async function createProductionEntry(data) {
  return BackendService.post('/items/production/', data);
}
async function getProductions(params) {
  return BackendService.getData('/items/production/', {}, params);
}
async function getStockBatches(params) {
  return BackendService.getData('/batches/items/', {}, params);
}
async function getStockBatch(id) {
  return BackendService.getData(`/batches/items/${id}/`);
}
async function updateStockBatch(id, data = {}) {
  return BackendService.patch(`/batches/items/${id}/`, data);
}

const ItemService = {
  getItems,
  getItemsResponse,
  getItemNames,
  updateItem,
  addItem,
  getItemCategories,
  addItemCategory,
  deleteItemCategory,
  editItemCategory,
  uploadCategoryImage,
  uploadItemImage,
  updatePlu,
  updateItems,
  getItemAdvanced,
  updateItemAdvanced,
  getHighestPlu,
  createProductionEntry,
  deleteItem,
  getProductions,
  getStockBatches,
  getStockBatch,
  updateStockBatch,
};

export default ItemService;
